import { SxProps, Theme } from "@mui/material/";

export const timeBoxContainer: SxProps<Theme> = {
  width: "100%",
  height: "19px",
};

export const timeBoxDateText: SxProps<Theme> = {
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "normal",
  fontStyle: "normal",
  color: "#000",
};

export const timeBoxTitleText: SxProps<Theme> = {
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "normal",
  fontStyle: "normal",
  color: "#000",
  marginLeft: "1px",
};
